// Shared error formatting for the inquiry-processor API calls.

// Validation errors come back as an array of messages; join for display.
export function apiErrorMessage(err: unknown): string {
  const raw = (err as { response?: { data?: { message?: string | string[] } } })?.response?.data?.message;
  return Array.isArray(raw) ? raw.join('\n') : raw || (err as Error)?.message || 'Please try again.';
}
